import { useEffect, useState } from "react";

// useDebouncedValue returns `value` once it has stopped changing for
// `delayMs`. Used to send search-as-you-type to the server once per pause
// rather than once per keystroke.
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
